import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import remarkBreaks from 'remark-breaks'

// A ticket message's body: customer and staff replies, the tracker description and agent drafts. Messages carry long
// unbroken runs (URLs, email addresses, Outlook's `name@x<mailto:name@x>`) that would otherwise spill out of their
// card, so they wrap anywhere; `anywhere` rather than `break-word` because it also shrinks the min-content width the
// flex rows size from. Code and tables keep their shape and scroll inside the card instead.
export function MessageMarkdown({ children }: { children: string }) {
  return (
    <div className="prose prose-sm dark:prose-invert max-w-none wrap-anywhere text-etn-text-cell prose-pre:overflow-x-auto prose-table:block prose-table:overflow-x-auto">
      <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]}>{children}</ReactMarkdown>
    </div>
  )
}
